import { useSelector } from "react-redux";

// Scss
import "./ContractorAnalysis.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import CAIcon from "assets/icons/ca-icon.svg";
import BriefcaseIcon from "assets/icons/briefcase.svg";
import CostValueIcon from "assets/icons/cost-value.svg";
import PieSlicesIcon from "assets/icons/pie-slices.svg";
import WalletIcon from "assets/icons/wallet.svg";
// import NoteWhiteIcon from "assets/icons/note-white.svg";
import TTCIcon from "assets/icons/ttc.svg";
import TTCIconLight from "assets/icons/ttc-light.svg";

// Importing Components
import BubbleChart from "components/charts/BubbleChart"
import SmallPie from "components/charts/SmallPie";

// Importing Packages
import "animate.css";

function ContractorAnalysis() {
  const seletedTheme = useSelector((state) => state.globalConfig.theme);

  return (
    <>
       {/* Dropdowns Wrapper */}
       <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {seletedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {seletedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {seletedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {seletedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {seletedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {seletedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Contract Analysis Pane */}
      <section className="contract-analysis-wrapper">
        <div className="contract-analysis-container">
          <div className="cp-title">
            <img src={CAIcon} alt="#" />
            <span>Contract Analysis</span>
          </div>
          <div className="cp-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice And Right Section Slice Info */}
      <section className="grid-wrapper-ca">
        <div className="left-section-container">
          <div className="top">
            <div className="info">
              <div className="basic-tile projects">
                <div className="icon-container">
                  <img src={BriefcaseIcon} alt="#" />
                </div>
                <div className="title">Projects</div>
                <div className="values">630</div>
              </div>
            </div>
            <div className="info">
              <div className="budget-revised">
                <div className="budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span className="budget-white">Budget</span>
                  </div>
                  <div className="information">
                    <span className="budget-currency">33,597</span>
                    <span className="budget-sar">SAR</span>
                  </div>
                </div>
                <div className="revised-budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span className="budget-white">
                      Revised <br />
                      Budget
                    </span>
                  </div>
                  <div className="information">
                    <span className="budget-currency">33,597</span>
                    <span className="budget-sar">SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="e-p-costvalue">
                <div className="p-cost-value blank">
                  <div className="icon-container">
                    <img src={CostValueIcon} alt="#" />
                    <span>
                      Planed Cost <br /> Value
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
                <div className="e-cost-value blank">
                  <div className="icon-container">
                    <img src={CostValueIcon} alt="#" />
                    <span>
                      Earned Cost <br /> Value
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="pie-info">
                <div className="icon-container">
                  <img src={PieSlicesIcon} alt="#" />
                </div>
                <span>SPI</span>
                <div className="chart">
                  <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                  <span>45%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-section-container">
          <div className="body">
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Contractor</th>
                    <th># Of Projects</th>
                    <th>Budgets SAR</th>
                    <th>SPI</th>
                    <th>Scheduled Variance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                    <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                  <tr>
                  <td>تكاليف الرتقبها أن عدم</td>
                    <td>3</td>
                    <td>123,342,344</td>
                    <td>123,342,344</td>
                    <td>-234,123,342,344</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Average Contracts / No of Contracts Section */}
      <section className="avg-no-contracts-wrapper">
        <div className="avg-no-contracts-container">
          <div className="left">
            <div className="info">
              <div className="budget-revised">
                <div className="budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span>Budget</span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
                <div className="revised-budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span>
                      Revised <br />
                      Budget
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info background">
              <div className="head">
                <span>
                {seletedTheme === "dark" ? (
                    <img src={TTCIcon} alt="#" />
                  ) : (
                    <img src={TTCIconLight} alt="#" />
                  )}
                  Avg.Contractor Performance / Total Projects Budget
                </span>
              </div>
              <div className="body">
                <div className="chart-container">
                  {seletedTheme === 'dark'? <BubbleChart labelx={"#f1f2f3"} />: <BubbleChart labelx={"#6E7D87"}/>}
                   
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
              {seletedTheme === "dark" ? (
                  <img src={TTCIcon} alt="#" />
                ) : (
                  <img src={TTCIconLight} alt="#" />
                )}
                No Of Contracts per Top 10 Performed Contractors</span>
            </div>
            <div className="body">
              <div className="chart-container">
                <div className="chart-wrapper">
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">45%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "65%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">81%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "81%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">32%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "32%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">22%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "22%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">36%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "36%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">82%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "82%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">62%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "62%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">54%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "54%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                  <div className="vertical-bar-container">
                    <div className="stand-bar">
                      <span className="percentage">77%</span>
                      <div className="bar">
                        <div className="progress" style={{ height: "77%" }}>
                          <div className="glow"></div>
                        </div>
                      </div>
                      <span className="value"></span>
                      <span className="amount">تكاليف الرتقبها أن عدم</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContractorAnalysis;
